import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const InvalidEmail = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="bg-muted flex min-h-full flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-md flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <img src="/logo-black.svg" alt="Rebuild" className="h-8" />
        </a>
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Account Not Found</CardTitle>
            <CardDescription>
              We could not find an account for that email address. If you're
              unable to log in, please reach out to your Rebuild administrator
              or contact support.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" onClick={() => navigate("/")}>
              Try again
            </Button>
          </CardContent>
        </Card>
        <div className="text-balance text-center text-xs text-muted-foreground">
          Need help?{" "}
          <a
            href="mailto:admin@rebuild.work"
            className="underline underline-offset-4 hover:text-primary"
          >
            admin@rebuild.work
          </a>
        </div>
      </div>
    </div>
  );
};
